import configPath from '../../config/app-config.json';

import type {AppConfig} from './typedefs';

let appConfig: AppConfig;

export const error = 'app-config.json was not received';

export const getAppConfig = async (): Promise<AppConfig> => {
    if (!appConfig) {
        appConfig = await fetch(configPath as unknown as string)
            .then(res => res.json())
            .catch(() => {
                throw new Error(error);
            });
    }

    return appConfig;
};
